import { shallowMount } from "@vue/test-utils";
import Container from "@/components/core/Container";

describe("Container test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Container);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Container", () => {
    expect(wrapper).toBeDefined();
  });
});
